import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetAttScheduleDetailState, getAttScheduleDetail as onGetAttScheduleDetails, addNewAttScheduleDetail as onAddNewAttScheduleDetail, updateAttScheduleDetail as onUpdateAttScheduleDetail, deleteAttScheduleDetail as onDeleteAttScheduleDetail, getAttScheduleDetailLoading } from "../../../store/attScheduleDetail/action";
import { getAttSchedule as onGetAttSchedules, addNewAttSchedule as onAddNewAttSchedule, updateAttSchedule as onUpdateAttSchedule, deleteAttSchedule as onDeleteAttSchedule, getAttScheduleLoading, resetAttScheduleState } from "../../../store/attSchedule/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const AttSchedule = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [companyName, setCompanyName] = useState({});
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, attSchedules, isAttScheduleCreated, isAttScheduleSuccess, loading, error, attScheduleDetails, attScheduleDetailLoading, isAttScheduleDetailCreated, isAttScheduleDetailSuccess, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    attSchedules: state.AttSchedule.attSchedules,
    isAttScheduleCreated: state.AttSchedule.isAttScheduleCreated,
    isAttScheduleSuccess: state.AttSchedule.isAttScheduleSuccess,
    loading: state.AttSchedule.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.AttSchedule.error,
    attScheduleDetails: state.AttScheduleDetail.attScheduleDetails,
    attScheduleDetailLoading: state.AttScheduleDetail.loading,
    isAttScheduleDetailCreated: state.AttScheduleDetail.isAttScheduleDetailCreated,
    isAttScheduleDetailSuccess: state.AttScheduleDetail.isAttScheduleDetailSuccess,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [attScheduleList, setAttScheduleList] = useState([]);
  const [attSchedule, setAttSchedule] = useState([]);
  const [scheduleDetailAddedId, setScheduleDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [attScheduleDetail, setAttScheduleDetail] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [searchValueSecond, setSearchValueSecond] = useState([]);

  const dayName = [
    {
      options: [
        { label: "Minggu", value: "Sunday" },
        { label: "Senin", value: "Monday" },
        { label: "Selasa", value: "Tuesday" },
        { label: "Rabu", value: "Wednesday" },
        { label: "Kamis", value: "Thursday" },
        { label: "Jum'at", value: "Friday" },
        { label: "Sabtu", value: "Saturday" },
      ],
    },
  ];

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (attSchedule) => {
    setAttSchedule(attSchedule);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (attScheduleDetail) => {
    setAttScheduleDetail(attScheduleDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteAttSchedule = () => {
    if (attSchedule) {
      dispatch(onDeleteAttSchedule(attSchedule));
      setDeleteModal(false);
    }
  };

  const handleDeleteAttScheduleDetail = () => {
    if (attScheduleDetail) {
      setScheduleDetailAddedId(attScheduleDetail.scheduleId);
      dispatch(onDeleteAttScheduleDetail(attScheduleDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setAttSchedule(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAttSchedules = attSchedules;
      if (type !== "all") {
        filteredAttSchedules = attSchedules.filter((attSchedule) => attSchedule.as_status.name === type);
      }
      setAttScheduleList(filteredAttSchedules);
    }
  };

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetAttScheduleState());
      dispatch(onGetAttSchedules({ companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(attSchedules)) {
      setIsEdit(false);
      let filteredAttSchedules = attSchedules;
      if (activeTypeTab !== "all") {
        filteredAttSchedules = attSchedules.filter((attSchedule) => attSchedule.as_status.name === activeTypeTab);
      }
      setAttScheduleList(filteredAttSchedules);
      let current = 0;
      if (scheduleDetailAddedId !== 0) {
        attSchedules.forEach((obj, i) => {
          if (obj.id === scheduleDetailAddedId) current = i;
        });
      }
      setInfo(attSchedules[current]);
    }
  }, [attSchedules, scheduleDetailAddedId]);

  useEffect(() => {
    if (isAttScheduleDetailCreated) {
      dispatch(resetAttScheduleDetailState());
      dispatch(resetAttScheduleState());
      dispatch(onGetAttSchedules());
    }
  }, [dispatch, isAttScheduleDetailCreated]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAttSchedule(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleAttScheduleClick = useCallback(
    (arg) => {
      const data = arg;
      setAttSchedule({
        id: data.id,
        name: data.name,
        company: data.as_company && {
          label: data.as_company ? data.as_company.name : "",
          value: data.as_company ? data.as_company.id : "",
        },
        client: data.as_client && {
          label: data.as_client ? data.as_client.name : "",
          value: data.as_client ? data.as_client.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setAttScheduleDetail(null);
      setAttSchedule(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleAttScheduleDetailClick = useCallback(
    (arg, isEdit) => {
      const data = arg;
      setAttScheduleDetail({
        id: data.id,
        name: { label: data.name, value: data.name },
        companyId: data.companyId,
        scheduleId: data.scheduleId,
        clockinat: data.clockinat,
        clockoutat: data.clockoutat,
        breakinat: data.breakinat,
        breakoutat: data.breakoutat,
        overtimeinat: data.overtimeinat,
        overtimeoutat: data.overtimeoutat,
      });

      setIsEditDetail(isEdit);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAttendanceSchedule") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAttScheduleClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAttendanceSchedule") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveAttendanceSchedule") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui jadwal ${data.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Jadwal",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "as_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [handleAttScheduleClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: attScheduleList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("createAttendanceSchedule") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAttScheduleDetailClick(data, false);
                    }}
                  >
                    <i className="ri-file-copy-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAttendanceSchedule") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAttScheduleDetailClick(data, true);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAttendanceSchedule") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDeleteDetail(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Hari",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Waktu Kerja",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <span className="fw-semibold mb-1">
                {cellProps.row.original.clockinat ? cellProps.row.original.clockinat : "-"} - {cellProps.row.original.clockoutat ? cellProps.row.original.clockoutat : "-"}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Waktu Istirahat",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <span className="fw-semibold mb-1">
                {cellProps.row.original.breakinat ? cellProps.row.original.breakinat : "-"} - {cellProps.row.original.breakoutat ? cellProps.row.original.breakoutat : "-"}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Waktu Lembur",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <span className="fw-semibold mb-1">
                {cellProps.row.original.overtimeinat ? cellProps.row.original.overtimeinat : "-"} - {cellProps.row.original.overtimeoutat ? cellProps.row.original.overtimeoutat : "-"}
              </span>
            </div>
          );
        },
      },
    ],
    [info]
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveSchedule = () => {
    if (attSchedule) {
      attSchedule.setApprove = true;
      dispatch(onUpdateAttSchedule(attSchedule));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (attSchedule && attSchedule.name) ?? "",
      client: (attSchedule && attSchedule.client) || clientSelected,
      company: (attSchedule && attSchedule.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Schedule Name"),
      client: Yup.object().required("Silahkan isi grup perusahaan"),
      company: Yup.object().required("Please Select company"),
    }),
    onSubmit: (values) => {
      dispatch(getAttScheduleLoading());
      if (isEdit) {
        const updateAttSchedule = {
          id: attSchedule ? attSchedule.id : 0,
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          statusId: 2,
        };
        dispatch(onUpdateAttSchedule(updateAttSchedule));
        validation.resetForm();
      } else {
        const newAttSchedule = {
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          statusId: 2,
        };
        dispatch(onAddNewAttSchedule(newAttSchedule));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      companyId: (attScheduleDetail && attScheduleDetail.companyId) || (info && info.companyId),
      scheduleId: (attScheduleDetail && attScheduleDetail.scheduleId) || (info && info.id),
      name: (attScheduleDetail && attScheduleDetail.name) ?? "",
      clockinat: (attScheduleDetail && attScheduleDetail.clockinat) ?? "",
      clockoutat: (attScheduleDetail && attScheduleDetail.clockoutat) ?? "",
      breakinat: (attScheduleDetail && attScheduleDetail.breakinat) ?? "",
      breakoutat: (attScheduleDetail && attScheduleDetail.breakoutat) ?? "",
      overtimeinat: (attScheduleDetail && attScheduleDetail.overtimeinat) ?? "",
      overtimeoutat: (attScheduleDetail && attScheduleDetail.overtimeoutat) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.object().required("Please Pick Day Name"),
      clockinat: Yup.string().required("Please Pick Clock In"),
      clockoutat: Yup.string().required("Please Enter Clock Out"),
      breakinat: Yup.string().required("Please Pick Break In"),
      breakoutat: Yup.string().required("Please Pick Break Out"),
    }),
    onSubmit: (values) => {
      setScheduleDetailAddedId(values.scheduleId);
      dispatch(getAttScheduleLoading());
      if (isEditDetail) {
        const updateAttScheduleDetail = {
          id: attScheduleDetail ? attScheduleDetail.id : 0,
          name: values.name.value,
          clockinat: values.clockinat,
          clockoutat: values.clockoutat,
          breakinat: values.breakinat,
          breakoutat: values.breakoutat,
          overtimeinat: values.overtimeinat,
          overtimeoutat: values.overtimeoutat,
          scheduleId: values.scheduleId,
          companyId: values.companyId,
        };
        dispatch(onUpdateAttScheduleDetail(updateAttScheduleDetail));
        validationDetail.resetForm();
      } else {
        const newAttScheduleDetail = {
          name: values.name.value,
          clockinat: values.clockinat,
          clockoutat: values.clockoutat,
          breakinat: values.breakinat,
          breakoutat: values.breakoutat,
          overtimeinat: values.overtimeinat,
          overtimeoutat: values.overtimeoutat,
          scheduleId: values.scheduleId,
          companyId: values.companyId,
        };
        dispatch(onAddNewAttScheduleDetail(newAttScheduleDetail));
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAttScheduleDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleAttScheduleStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetAttSchedules(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAttScheduleList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetAttScheduleState());
    dispatch(onGetAttSchedules({ companyId: companySelected?.value ?? "" }));
  };

  useEffect(() => {
    if (info && info.as_detail) {
      setDetailList(info.as_detail);
    }
  }, [info]);

  document.title = "Jadwal Kehadiran | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={attSchedule && attSchedule.contract_employee ? attSchedule.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveSchedule} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAttSchedule} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteAttScheduleDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Penggajian" pageTitle="Jadwal Kehadiran" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAttendanceSchedule") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={5}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i>SEMUA JADWAL KEHADIRAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Jadwal Kehadiran" : "Tambah Jadwal Kehadiran"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;{" "}
                            {clientLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              validation.setFieldValue("client", e);
                            }}
                            options={clientList}
                          ></Select>
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;{" "}
                            {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              dispatch(setBranchSelect(null));
                              dispatch(setCompanySelect(e));
                              validation.setFieldValue("company", e);
                            }}
                            options={companyList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name-field" className="form-label">
                            Nama Jadwal
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Jadwal" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Ubah Jadwal" : "Tambah Jadwal"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="name" className="form-label">
                            Hari
                            {companyLoading ? (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </Label>
                          <Select
                            name="name"
                            placeholder="Pilih Hari"
                            value={validationDetail.values.name}
                            onChange={(e) => {
                              validationDetail.setFieldValue("name", e);
                            }}
                            options={dayName}
                          ></Select>
                          {validationDetail.touched.name && validationDetail.errors.name ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.name}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="clockinat-field" className="form-label">
                            Jam Masuk
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="clockinat-field"
                            name="clockinat"
                            value={validationDetail.values.clockinat}
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              time_24hr: true,
                            }}
                            onChange={(obj, str) => {
                              validationDetail.setFieldValue("clockinat", str);
                            }}
                          />
                          {validationDetail.touched.clockinat && validationDetail.errors.clockinat ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.clockinat}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="clockoutat-field" className="form-label">
                            Jam Keluar
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="clockoutat-field"
                            name="clockoutat"
                            value={validationDetail.values.clockoutat}
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              time_24hr: true,
                            }}
                            onChange={(obj, str) => {
                              validationDetail.setFieldValue("clockoutat", str);
                            }}
                          />
                          {validationDetail.touched.clockoutat && validationDetail.errors.clockoutat ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.clockoutat}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="breakinat-field" className="form-label">
                            Jam Istirahat
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="breakinat-field"
                            name="breakinat"
                            value={validationDetail.values.breakinat}
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              time_24hr: true,
                            }}
                            onChange={(obj, str) => {
                              validationDetail.setFieldValue("breakinat", str);
                            }}
                          />
                          {validationDetail.touched.breakinat && validationDetail.errors.breakinat ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.breakinat}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="breakoutat-field" className="form-label">
                            Jam Istirahat Selesai
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="breakoutat-field"
                            name="breakoutat"
                            value={validationDetail.values.breakoutat}
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              time_24hr: true,
                            }}
                            onChange={(obj, str) => {
                              validationDetail.setFieldValue("breakoutat", str);
                            }}
                          />
                          {validationDetail.touched.breakoutat && validationDetail.errors.breakoutat ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.breakoutat}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="overtimeinat-field" className="form-label">
                            Jam Lembur
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="overtimeinat-field"
                            name="overtimeinat"
                            value={validationDetail.values.overtimeinat}
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              time_24hr: true,
                            }}
                            onChange={(obj, str) => {
                              validationDetail.setFieldValue("overtimeinat", str);
                            }}
                          />
                          {validationDetail.touched.overtimeinat && validationDetail.errors.overtimeinat ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.overtimeinat}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="overtimeoutat-field" className="form-label">
                            Jam Lembur Selesai
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="overtimeoutat-field"
                            name="overtimeoutat"
                            value={validationDetail.values.overtimeoutat}
                            options={{
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              time_24hr: true,
                            }}
                            onChange={(obj, str) => {
                              validationDetail.setFieldValue("overtimeoutat", str);
                            }}
                          />
                          {validationDetail.touched.overtimeoutat && validationDetail.errors.overtimeoutat ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.overtimeoutat}
                            </small>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={7}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-success add-btn" : userRole && userRole.split(",").indexOf("createAttendanceSchedule") !== -1 ? "btn btn-success add-btn" : "btn btn-success add-btn d-none"}
                    id="create-btn"
                    onClick={() => {
                      setAttSchedule(info);
                      setIsEditDetail(false);
                      toggleDetail();
                    }}
                  >
                    <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                    Tambah Detail
                  </button>
                  <button className="ms-2 btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                    <i className="ri-delete-bin-5-line me-1 align-bottom fs-14"></i>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="card-body">
                  <Row>
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2">
                              <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                                {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                  <option key={pageSizeSecond} value={pageSizeSecond}>
                                    {pageSizeSecond}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValueSecond(e.target.value);
                                  onChangeSecond(e.target.value);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`Cari...`}
                                value={searchValueSecond ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroupsSecond.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyPropsSecond()}>
                        {pageSecond.map((row) => {
                          prepareRowSecond(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} defaultValue={pageIndexSecond + 1} onChange={onChangeInInputSecond} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AttSchedule;
